import {
    CONFIRMED_GET_PURCHASEPLANS
} from '../actions/PurchasePlan/PurchasePlanTypes';
const initialState = {
    purchasePlan: [],
    loading: false,
};

function PurchasePlanReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'PURCHASE_PLAN_LOADING':
            return {
                ...state,
                loading: true,
            };
        case CONFIRMED_GET_PURCHASEPLANS:
            return {
                ...state,
                purchasePlan: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {PurchasePlanReducer};